"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BreadcrumbItem = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _Link = require("../../react-static/components/Link");

var BreadcrumbItem =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(BreadcrumbItem, _Component);

  function BreadcrumbItem(props) {
    return _Component.call(this, props) || this;
  } // static contextType = LinkContext;


  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    // const Link = this.context;
    var _this$props = this.props,
        label = _this$props.label,
        to = _this$props.to,
        separator = _this$props.separator; // React router needed exact, reach router??

    var item = to ? _react.default.createElement(_Link.Link, {
      to: to
    }, label) : _react.default.createElement("span", null, label);

    if (separator) {
      return _react.default.createElement("span", null, "\xA0", separator, " ", item);
    } else {
      return item;
    }
  };

  return BreadcrumbItem;
}(_react.Component);

exports.BreadcrumbItem = BreadcrumbItem;